<template>
    <Upload
        ref="upload"
        class="upload"
        :style="{'background-image': 'url(' +  (!isUpload? beforeBack : afterBack) + ')'}"
        :action= 'actionUrl'
        :show-upload-list='false'
        :before-upload="handleUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :headers="{//请求头
            Authorization: gettoken,
            'Accept-Language':lang
        }"
        :data="{
            type:type    
        }"
        :disabled="isDisabled"
    >
        <div  class="upload_content" v-if="!isUpload">
            <!-- <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon> -->
            <img src="../assets/image/card-camera.png" alt="">
            <p>{{label}}</p>
        </div>
        <div v-else class="upload_edit">
            <!-- <img :src="afterBack" alt=""> -->
            <Button @click="modifyUpload">{{$t('uploadEdit')}}</Button>
            <Button @click="deleteUpload">{{$t('uploadDelete')}}</Button>
        </div>
        <loading :isSpinShow="loading"></loading>
    </Upload>
    
</template>
<script>
import {mapState} from 'vuex'
import Loading from '@/components/Loading.vue';

// import Config from '../plugins/config.js'
    export default {
        components: {
            Loading
        },
        props: ['label','beforeBack','type','photo'],
        data () {
            return {
                isUpload:false,
                isDisabled:false,
                afterBack:'',
                loading:false,
                actionUrl:API_URL+'api/Files/UploadFile',
                gettoken:''
            }
        },
        computed: {
            ...mapState(['lang','userInfo','token'])
        },
        created(){
            console.log(this.photo)
            this.gettoken = 'Bearer ' + this.token
            
        },
        watch: {
            photo(val){
                if(val){
                    this.afterBack = API_URL+'api/Files/DownloadFile?fileName='+ this.photo
                    this.isUpload = true
                    this.isDisabled = true
                }else{
                    this.isUpload = false
                    this.isDisabled = false
                }
            }
        },
        methods: {
            uploadSuccess (response, file, fileList) {
                // console.log(file)
                this.loading  = false
                if(response.status == 1){
                    this.isUpload = true
                    this.isDisabled = true
                    this.afterBack = API_URL+'api/Files/DownloadFile?fileName='+ response.obj.pathName
                    this.$emit('getData')
                }else{
                    this.$Message.error(response.msg)
                }

            },
            handleUpload (file) {
                this.loading = true
            },
            uploadError (response, file, fileList) {
                this.loading  = false
                // console.log(response)
            },
            modifyUpload(){
                this.isDisabled = false
            },
            deleteUpload(){
                this.isDisabled = true
                this.loading = true
                let params = {
                    type:this.type,
                    fileName:this.photo
                }
                this.$axios.post('/api/Files/DeleteFile', params)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            this.$Message.success(this.$t('deleteSuccess'))
                            this.$emit('getData')
                            // this.$Message.success(this.$t('loginsuccess'))
                            // this.$store.commit('setToken', res.data.obj.token)
                            // this.$store.commit('setUserInfo', res.data.obj.userInfo)
                            // this.$router.push({ path:'/myAccount'})
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)
                // this.$refs.upload.clearFiles()
            }
        },
    }
</script>
<style lang="less" >
.upload{
    .upload_edit{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.3);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button{
                width: 140px;
                font-size: 14px;
                color: #e32b3a;
                line-height: 40px;
                height: 42px;
                margin-bottom: 18px;
                text-align: center;
                background-color: #fff;
                border-radius: 21px;
                padding: 0;
        }
    }
}

</style>
